import { Accessor, Position } from '@deck.gl/core';
import { HidableLineLayer } from '../../line/hidable-line-layer';
import vertexShader from './leader-line-layer-vertex-shader.glsl?raw';

export class LeaderLineLayer<TData, TProps = object> extends HidableLineLayer<
    TData,
    TProps & {
        getPosition: Accessor<TData, Position>;
        getPixelOffset: Accessor<TData, [number, number]>;
    }
> {
    initializeState() {
        super.initializeState();
        this.getAttributeManager()!.remove(['instanceSourcePositions']);
        this.getAttributeManager()!.remove(['instanceTargetPositions']);
        this.getAttributeManager()!.addInstanced({
            instanceSourcePositions: {
                size: 3,
                type: 'float32',
                accessor: 'getPosition'
            },
            instanceTargetOffsets: {
                size: 2,
                type: 'float32',
                accessor: 'getPixelOffset'
            }
        });
    }

    getShaders() {
        const superShaders = super.getShaders();
        return {
            ...superShaders,
            modules: [...superShaders.modules],
            vs: vertexShader
        };
    }
}
